/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum ClaimSubmitStatusEnum {
    INVALID = 'orcan.claims.claim.send.sap.data.hu-invalid',
    MISSING = 'orcan.claims.claim.send.sap.data.missing',
    FILE_MANAGER_SERVICE_UNAVAILABLE = 'orcan.claims.service.file-manager.service-unavailable',
    HANDLING_UNIT_SERVICE_UNAVAILABLE = 'orcan.claims.service.handling-unit.service-unavailable'
}
